import { render, staticRenderFns } from "./GameSpeedDisplay.vue?vue&type=template&id=1b923d2a&scoped=true&"
import script from "./GameSpeedDisplay.vue?vue&type=script&lang=js&"
export * from "./GameSpeedDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GameSpeedDisplay.vue?vue&type=style&index=0&id=1b923d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b923d2a",
  null
  
)

export default component.exports